/* ============================================================
 * Contact Us Hero Section Parallax
 * ============================================================ */

(function () {
    'use strict';

    function reveal() {
        document.querySelectorAll('.contact-us-hero-section').forEach((section) => {
            section.querySelector('.contact-us-hero-section__portrait')?.classList.add('is-visible');
            section.querySelector('.contact-us-hero-section__landscape')?.classList.add('is-visible');
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            requestAnimationFrame(reveal);
        });
    } else {
        requestAnimationFrame(reveal);
    }
})();